export const news = [
  {
    id: "n01",
    title: "佐山爱携新片《流星的约定》亮相年度影展，红毯造型获赞",
    summary:
      "在第42届国际影展闭幕红毯上，佐山爱以一袭深海蓝礼服登场，为科幻爱情新片《流星的约定》宣传造势，现场媒体与影迷反响热烈。",
    date: "2024-09-18",
    author: "编辑部 · 林一",
    tags: ["影展", "新片", "红毯"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20elegant%20film%20festival%20red%20carpet%20scene%20at%20dusk%20with%20deep%20navy%20blue%20backdrop%20and%20warm%20amber%20spotlights%2C%20cinematic%20premiere%20atmosphere%2C%20no%20recognizable%20faces%2C%20minimal%20luxurious%20composition&width=800&height=600&seq=wk-news-thumb-01&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20shot%20of%20a%20grand%20film%20festival%20auditorium%20entrance%20with%20deep%20navy%20curtains%20and%20warm%20golden%20marquee%20lights%20at%20night%2C%20cinematic%20premiere%20mood%2C%20no%20recognizable%20faces%2C%20elegant%20minimal%20composition&width=1200&height=675&seq=wk-news-inline-01&orientation=landscape",
    content: [
      "第42届国际影展于本周闭幕，佐山爱作为主竞赛单元入围影片《流星的约定》的主演，受邀出席闭幕红毯。当晚她以一袭深海蓝丝绒礼服亮相，与影片的科幻气质相互呼应，成为红毯上最受关注的焦点之一。",
      "在随后的媒体见面会上，佐山爱分享了拍摄期间的幕后故事。她提到，为了呈现观测员长期在暗光环境中工作的状态，剧组专门搭建了一座全比例的天文台内景，她与团队在封闭空间里连续拍摄了近一个月。",
      "《流星的约定》讲述了观测员在流星雨之夜接收到一段来自过去的信号，并由此展开一段跨越时间的旅程。影片在放映后收获了观众长时间的掌声，多家媒体评价其「浪漫与科幻的平衡令人惊喜」。",
      "影展结束后，影片将于下月起陆续在各大院线上映。佐山爱表示，希望这部作品能让观众在欣赏华丽视觉的同时，也重新思考记忆与约定的意义。",
    ],
  },
  {
    id: "n02",
    title: "《樱花车站》正式杀青，佐山爱：这是我这三年最温柔的一次拍摄",
    summary:
      "治愈系剧集《樱花车站》历经四个月拍摄正式杀青，全剧以四季流转为线索，预计明年春季与观众见面。",
    date: "2024-08-02",
    author: "编辑部 · 佐野",
    tags: ["剧集", "杀青", "治愈"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20small%20rural%20train%20platform%20surrounded%20by%20soft%20spring%20blossoms%20in%20gentle%20morning%20light%2C%20warm%20cream%20and%20pink%20palette%2C%20peaceful%20nostalgic%20mood%2C%20no%20recognizable%20faces%2C%20minimal%20composition&width=800&height=600&seq=wk-news-thumb-02&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20a%20quiet%20countryside%20railway%20line%20winding%20through%20blooming%20trees%20under%20a%20soft%20pale%20sky%2C%20warm%20spring%20tones%2C%20serene%20cinematic%20mood%2C%20no%20people%2C%20minimal%20elegant%20composition&width=1200&height=675&seq=wk-news-inline-02&orientation=landscape",
    content: [
      "经过近四个月的紧张拍摄，治愈系剧集《樱花车站》正式杀青。剧组在最后一站拍摄地举行了简短的杀青仪式，主创团队与工作人员共同庆祝这段漫长的旅程告一段落。",
      "佐山爱在剧中饰演一位即将随着车站一同告别岗位的站务员。她坦言，这是自己近三年里最温柔的一次拍摄经历：「每天收工的时候天都快亮了，大家却还是一遍遍地说着谢谢。这种氛围会留在心里很久。」",
      "据制片方介绍，剧集以春、夏、秋、冬四季为章节，每个季节都有独立的故事单元，同时贯穿一条关于重逢与告别的温暖主线。为了还原真实的车站质感，美术团队在郊外搭建了一比一的实景。",
      "《樱花车站》目前进入后期制作阶段，预计将于明年春季正式上线，具体播出平台和时间将在后续公布。",
    ],
  },
  {
    id: "n03",
    title: "专访佐山爱：比起被记住，我更想留下值得回味的角色",
    summary:
      "在最新一期专访中，佐山爱聊到了自己挑选剧本的标准、对表演的理解，以及一路走来对「演员」二字的重新认识。",
    date: "2024-07-11",
    author: "编辑部 · 陈默",
    tags: ["专访", "演员", "访谈"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20warm%20minimalist%20interview%20room%20with%20wooden%20furniture%20and%20soft%20natural%20window%20light%2C%20beige%20and%20cream%20palette%2C%20calm%20thoughtful%20mood%2C%20no%20recognizable%20faces%2C%20elegant%20composition&width=800&height=600&seq=wk-news-thumb-03&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20an%20empty%20warm%20minimalist%20studio%20corner%20with%20a%20single%20chair%20and%20soft%20daylight%2C%20muted%20beige%20tones%2C%20quiet%20contemplative%20cinematic%20mood%2C%20no%20people%2C%20minimal%20composition&width=1200&height=675&seq=wk-news-inline-03&orientation=landscape",
    content: [
      "在这次长约两小时的专访里，佐山爱几乎没有回避任何问题。她坐在靠窗的位置，语速不快，但每一个回答都经过了认真的思考。",
      "谈到挑选剧本的标准，她说自己越来越在意「角色是否值得被反复想起」。「比起被观众记住我这个人，我更希望他们某天想起某个角色时，心里还会被轻轻触一下。」",
      "对于外界常说的「文艺片专业户」标签，她笑着回应：「其实我没有刻意选择类型，只是那些角色刚好打动了我。喜剧我也演过，动作戏我也想尝试。」",
      "当被问到如何看待表演这件事时，她沉默了几秒，然后说：「表演让我学会了怎么和自己相处。每一个角色都像一面镜子，照见我不太愿意面对的那部分。」",
      "专访最后，她提到自己最近在重读几本旧剧本，也在学习一门新的乐器。「总得给自己找点新的事情做，不然人会变得迟钝。」",
    ],
  },
  {
    id: "n04",
    title: "《城市晚风》收视口碑双丰收，深夜电台故事引发广泛共鸣",
    summary:
      "都市剧《城市晚风》播出过半，凭借细腻的人物刻画与真实的都市质感，收获了大量观众的自发讨论与好评。",
    date: "2024-06-05",
    author: "编辑部 · 林一",
    tags: ["剧集", "口碑", "都市"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20rainy%20city%20street%20at%20night%20with%20warm%20streetlight%20reflections%20on%20wet%20asphalt%20and%20distant%20blue%20hour%20skyline%2C%20urban%20moody%20atmosphere%2C%20no%20recognizable%20faces%2C%20minimal%20cinematic%20composition&width=800&height=600&seq=wk-news-thumb-04&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20a%20dim%20late-night%20radio%20studio%20with%20a%20warm%20desk%20lamp%20and%20microphone%2C%20deep%20blue%20shadows%20and%20amber%20highlights%2C%20intimate%20quiet%20urban%20mood%2C%20no%20people%2C%20minimal%20composition&width=1200&height=675&seq=wk-news-inline-04&orientation=landscape",
    content: [
      "都市剧《城市晚风》自开播以来，收视率持续走高，社交平台上关于剧情的讨论量也在稳步攀升。不少观众表示，剧中深夜电台的设定让他们想起了自己城市里那些安静的夜晚。",
      "佐山爱在剧中饰演一位深夜电台主持人，白天与夜晚仿佛活在两个世界。她认为，这个角色最打动自己的地方在于「她在别人面前很会安慰人，唯独对不了自己」。",
      "导演陈子墨透露，为了拍出真实的夜戏质感，团队大量采用实景拍摄，很多镜头是在真实的深夜街区完成。「我们希望观众能闻到雨后的空气。」",
      "目前剧集已播出过半，后续剧情将围绕一场突如其来的城市停电展开。制片方表示，希望这部剧能让更多人愿意在忙碌之后，停下来听听身边的声音。",
    ],
  },
  {
    id: "n05",
    title: "佐山爱参与公益放映活动，与乡村孩子共上一堂「电影课」",
    summary:
      "日前，佐山爱随公益团队走进山区学校，参与了一场特别的电影放映活动，并为孩子们带来了一堂生动的影像启蒙课。",
    date: "2024-05-20",
    author: "编辑部 · 佐野",
    tags: ["公益", "活动", "影像"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20makeshift%20outdoor%20film%20screening%20in%20a%20mountain%20village%20at%20dusk%20with%20a%20warm%20glowing%20screen%2C%20gentle%20community%20mood%2C%20soft%20cream%20and%20amber%20tones%2C%20no%20recognizable%20faces%2C%20minimal%20composition&width=800&height=600&seq=wk-news-thumb-05&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20a%20simple%20village%20schoolyard%20at%20sunset%20with%20rows%20of%20empty%20wooden%20benches%20facing%20a%20blank%20outdoor%20screen%2C%20warm%20golden%20light%2C%20hopeful%20peaceful%20mood%2C%20no%20people%2C%20minimal%20cinematic%20composition&width=1200&height=675&seq=wk-news-inline-05&orientation=landscape",
    content: [
      "上周，佐山爱随公益团队来到山区的一所乡村小学，参与了一场特别的光影活动。白天，她与孩子们一起布置临时的放映场地；夜晚，大家围坐在操场上看完了一部关于梦想的老电影。",
      "「他们看电影时特别安静，散场后却问了好多问题。」佐山爱回忆道，「有个孩子问我，电影里的人是不是真的活在另一个世界里。我当时不知道怎么回答，只能说，也许我们每个人都在拍自己的电影。」",
      "除了放映，她还为孩子们带来了一堂简单的影像启蒙课，教大家用手机记录身边的光影变化。她说，希望这些孩子未来无论走到哪里，都能记得为生活按下一次快门。",
      "活动结束后，团队向学校捐赠了一批放映设备与影像读物。佐山爱表示，这样的活动她会一直参与下去。",
    ],
  },
  {
    id: "n06",
    title: "《追光者》发布首支预告，佐山爱挑战全新角色引期待",
    summary:
      "励志剧情片《追光者》近日发布首支预告片，佐山爱在片中饰演一名视力逐渐衰退的摄影师，全新的挑战引发影迷热烈讨论。",
    date: "2024-04-28",
    author: "编辑部 · 陈默",
    tags: ["新片", "预告", "期待"],
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20golden%20sunrise%20over%20a%20city%20rooftop%20skyline%20with%20soft%20haze%20and%20warm%20gradient%20sky%2C%20hopeful%20inspiring%20mood%2C%20no%20recognizable%20faces%2C%20minimal%20cinematic%20composition&width=800&height=600&seq=wk-news-thumb-06&orientation=landscape",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20a%20vintage%20camera%20resting%20on%20a%20wooden%20windowsill%20facing%20a%20soft%20golden%20morning%20city%20view%2C%20warm%20amber%20tones%2C%20quiet%20contemplative%20cinematic%20mood%2C%20no%20people%2C%20minimal%20elegant%20composition&width=1200&height=675&seq=wk-news-inline-06&orientation=landscape",
    content: [
      "励志剧情片《追光者》于近日发布首支预告片，短短两分钟的画面以清晨的城市为背景，配合舒缓的配乐，勾勒出一位摄影师与光之间的对话。",
      "佐山爱在片中饰演一名视力逐渐衰退的摄影师，她决定在完全失去光明之前，完成一组关于城市清晨的影像计划。为了更贴近角色，她在开拍前跟随多位摄影师进行了实地体验。",
      "预告片发布后，不少影迷在评论区留言表示「光看预告就有点想哭」。有影评人指出，影片将「失去」与「记录」两个主题处理得克制而动人。",
      "《追光者》目前已完成后期制作，具体上映日期将于近期公布。制片方透露，影片会选择在秋季这样一个「光线最温柔的季节」与观众见面。",
    ],
  },
];